import Cookies from 'cookie-universal'
import useSWR from 'swr'

import { type User, UserService } from '@mc/api'

export const useUserInfo = () => {
  const cookies = Cookies()
  const isLoggedIn = cookies.get('_mcl') === 1

  const { data: user, ...state } = useSWR<User>(
    isLoggedIn ? `/jsonapi/v1/users/current?deep=true` : null,
    () => UserService.getUser({ id: 'current', deep: true }),
  )

  return { ...state, user }
}
